/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { JobsControllerFindOneQueryResponse, JobsControllerFindOnePathParams, JobsControllerFindOneQueryParams, JobsControllerFindOne400, JobsControllerFindOne401, JobsControllerFindOne403, JobsControllerFindOne404 } from "../../models/jobsController/JobsControllerFindOne";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { jobsControllerFindOne } from "../../clients/jobsService/jobsControllerFindOne";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const jobsControllerFindOneQueryKey = (id: JobsControllerFindOnePathParams["id"], params: JobsControllerFindOneQueryParams = {}) => [{
  url: '/api/v1/jobs/:id',
  params: {
    id: id
  }
}, ...(params ? [params] : [])] as const;
export type JobsControllerFindOneQueryKey = ReturnType<typeof jobsControllerFindOneQueryKey>;
export function jobsControllerFindOneQueryOptions(id: JobsControllerFindOnePathParams["id"], params?: JobsControllerFindOneQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = jobsControllerFindOneQueryKey(id, params);
  return queryOptions<JobsControllerFindOneQueryResponse, ResponseErrorConfig<JobsControllerFindOne400 | JobsControllerFindOne401 | JobsControllerFindOne403 | JobsControllerFindOne404>, JobsControllerFindOneQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return jobsControllerFindOne(id, params, config);
    }
  });
}

/**
 * @summary Get a job by id
 * {@link /api/v1/jobs/:id}
 */
export function useJobsControllerFindOne<TData = JobsControllerFindOneQueryResponse, TQueryData = JobsControllerFindOneQueryResponse, TQueryKey extends QueryKey = JobsControllerFindOneQueryKey>(id: JobsControllerFindOnePathParams["id"], params?: JobsControllerFindOneQueryParams, options: {
  query?: Partial<QueryObserverOptions<JobsControllerFindOneQueryResponse, ResponseErrorConfig<JobsControllerFindOne400 | JobsControllerFindOne401 | JobsControllerFindOne403 | JobsControllerFindOne404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? jobsControllerFindOneQueryKey(id, params);
  const query = useQuery({
    ...jobsControllerFindOneQueryOptions(id, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<JobsControllerFindOne400 | JobsControllerFindOne401 | JobsControllerFindOne403 | JobsControllerFindOne404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}